export default (url) => {
  if (!url) return '#'
  const urlArr = url.split('/').slice(3).join('/')

  return urlArr
}
